import { faCartShopping, faChartColumn, faDollarSign, faGift } from '@fortawesome/free-solid-svg-icons';
import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import StatsItem from '../StatsItem';

class Stats extends Component {
	render() {
		const { loading, data, className, termId, schoolYearId, t } = this.props;
		const { lessonPaymentCount, lessonPaymentAmount, lessonPaymentAverage, lessonPaymentDiscount, collectedAmount } = data || { lessonPaymentCount: null, lessonPaymentAmount: null, lessonPaymentAverage: null, lessonPaymentDiscount: null };

		const comparisonLabel = schoolYearId ? t('SalesDashboard_SincePreviousYear') : t('SalesDashboard_SincePreviousPeriod');
		const revenueTooltip = termId ? t('Stats_RevenueTooltip_Term')
			: schoolYearId ? t('Stats_RevenueTooltip_SchoolYear')
			: collectedAmount ? t('Stats_RevenueTooltip_DateRangeWithInstalments')
			: t('Stats_RevenueTooltip_DateRange');

		return <Row className={className}>
			<Col md={3} sm={6}>
				<StatsItem
					colorClassName='bg-green'
					label={t('Stats_LessonPaymentsCount')}
					icon={faCartShopping}
					comparisonLabel={comparisonLabel}
					loading={loading}
					{...lessonPaymentCount}
				/>
			</Col>
			<Col md={3} sm={6}>
				<StatsItem
					colorClassName='bg-violet'
					label={t('Stats_LessonPaymentsAmount')}
					icon={faDollarSign}
					comparisonLabel={comparisonLabel}
					loading={loading}
					tooltip={revenueTooltip}
					{...lessonPaymentAmount}
					primaryLabel={collectedAmount ? t('Stats_BookedRevenue') : null}
					secondaryLabel={collectedAmount ? t('Stats_CollectedRevenue') : null}
					secondaryValueFormatted={collectedAmount && collectedAmount.valueFormatted}
					secondaryPercentageChange={collectedAmount && collectedAmount.percentageChange}
				/>
			</Col>
			<Col md={3} sm={6}>
				<StatsItem
					colorClassName='bg-orange'
					label={t('Stats_AverageLessonPayments')}
					icon={faChartColumn}
					comparisonLabel={comparisonLabel}
					loading={loading}
					{...lessonPaymentAverage}
				/>
			</Col>
			<Col md={3} sm={6}>
				<StatsItem
					colorClassName='bg-blue'
					label={t('Stats_LessonPaymentsDiscount')}
					icon={faGift}
					comparisonLabel={comparisonLabel}
					loading={loading}
					{...lessonPaymentDiscount}
				/>
			</Col>
		</Row >;
	}
}

export default withTranslation()(Stats);